<template>
    <CDropdown
            inNav
            class="c-header-nav-items"
            placement="bottom-end"
            add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img
                            src="../assets/img/avatar.webp"
                            class="c-avatar-img "
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <!--    <CDropdownItem>-->
        <!--      <CIcon name="cil-key" class="pl-1" /> تغییر کلمه عبور-->
        <!--    </CDropdownItem>-->
        <CDropdownItem v-on:click="onLogOut">
            <CIcon name="cil-lock-locked" class="pl-1"/>
            خروج
        </CDropdownItem>
    </CDropdown>
</template>

<script>
    import {signOut} from '../webservice/webservice';

    export default {
        name: 'TheHeaderDropdownAccnt',
        data() {
            return {
                itemsCount: 42
            }
        },
        methods: {
            onLogOut() {
                signOut(this.$http, this.$toasted);
                localStorage.removeItem('token');
                this.$store.commit('set', ['user', null]);
                this.$router.push('/pages/login')
            }
        }
    }
</script>

<style scoped>
    .c-icon {
        margin-right: 0.3rem;
    }
</style>
